<template>
    <auth-layout
        :progress="isUserComingFromLogin ? 0 : progress"
        :isPlain="isUserComingFromLogin"
        :isProgressBarHidden="isUserComingFromLogin"
        class="aligned-left"
    >
        <template #byword>
            <span v-html="$t('pages.auth.signup.steps.congratulations.byword')"></span>
        </template>

        <template #default>
            <common-content-wrapper width="small">
                <common-page-header :heading="pageHeading" :content="pageContent"></common-page-header>
            </common-content-wrapper>

            <template>
                <common-content-wrapper width="small">
                    <div class="page-copy page-copy--subheader">
                        <p>{{ $t('pages.auth.signup.steps.congratulations.verified.to_open') }}</p>
                    </div>
                </common-content-wrapper>

                <common-content-wrapper width="small">
                    <div class="page-copy">
                        <p class="page-copy__center">
                            <common-button
                                :route="{ name: 'index' }"
                                :label="$t('pages.auth.signup.steps.congratulations.verified.open_dashboard')"
                                type="primary"
                                size="large"
                            ></common-button>
                        </p>
                    </div>
                </common-content-wrapper>
            </template>
        </template>
    </auth-layout>
</template>

<script>
    import SignupPageMixin from 'mixins/SignupPageMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import UsersAPI from 'api/UsersAPI'
    import AuthAPI from 'api/AuthAPI'
    import GoogleAnalyticsService from 'services/GoogleAnalyticsService'

    export default {
        mixins: [SignupPageMixin],

        components: {
            AuthLayout,
        },

        data() {
            return {
                isSendingVerificationEmail: false,
                isVerificationEmailSent: false,
                isUserComingFromLogin: false,
            }
        },

        computed: {
            userId() {
                return this.$auth.getUser().id
            },

            resendButtonLabel() {
                if (this.isSendingVerificationEmail) {
                    return this.$t('pages.auth.signup.steps.congratulations.content.button.sending')
                }

                if (this.isVerificationEmailSent) {
                    return this.$t('pages.auth.signup.steps.congratulations.content.button.sent')
                }

                return this.$t('pages.auth.signup.steps.congratulations.content.button.send')
            },

            pageHeading() {
                return this.isUserComingFromLogin
                    ? this.$t('pages.auth.signup.steps.congratulations.validate_heading')
                    : this.$t('pages.auth.signup.steps.congratulations.heading')
            },

            pageContent() {
                return this.isUserComingFromLogin ? '' : this.$t('pages.auth.signup.steps.congratulations.description')
            },
        },

        methods: {
            resendVerificationEmail() {
                if (this.isSendingVerificationEmail || this.isVerificationEmailSent) {
                    return
                }

                this.isSendingVerificationEmail = true

                AuthAPI.resendVerificationEmail(this.userId).then(() => {
                    this.isSendingVerificationEmail = false
                    this.isVerificationEmailSent = true
                })
            },

            proceedToDashboard() {
                this.$auth.logOut()
                this.$router.push({ name: 'auth.login' })
            },
        },

        mounted() {
            if (!this.$router.previousRoute) {
                return
            }
            if (process.env.VUE_APP_ENV === 'production' && !this.$auth.getUser().isNotificationSentOnRegister) {
                UsersAPI.sendNewMemberRegisteredNotificationEmail()
            }

            GoogleAnalyticsService.emitRegistrationCompletedGoogleAnalytics(this.$ga)
        },

        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.isUserComingFromLogin = from.path === '/login'
            })
        },
    }
</script>

<style lang="scss" scoped>
    .aligned-left {
        text-align: left;
    }
</style>
